// FIXME: Fix import/named export issue for firebase
/* eslint-disable import/named */
import {
	signOut,
	signInWithEmailAndPassword,
	createUserWithEmailAndPassword,
	setPersistence,
	inMemoryPersistence,
	browserLocalPersistence,
	browserSessionPersistence,
	signInAnonymously,
	fetchSignInMethodsForEmail,
	reauthenticateWithCredential,
	EmailAuthProvider
} from 'firebase/auth'
import firebaseError from './auth-error'

/**
 * @param {*} auth firebase auth instance
 * @param {string} persistenceType 'session' or 'local'
 */
function setFirebasePersistence (auth, persistenceType = 'session') {
	const persistence =
        persistenceType === 'session'
        	? browserSessionPersistence
        	: persistenceType === 'local'
        		? browserLocalPersistence
        		: inMemoryPersistence

	return setPersistence(auth, persistence)
		.catch(firebaseError.parseError)
}

/**
 * @param {*} firebaseAuth firebase auth instance
 * @param {string} email
 * @param {string} password
 * @param {string} persistenceType 'session' or 'local'
 */
async function logInWithEmailAndPassword (firebaseAuth, email, password, persistenceType = 'session') {
	await setFirebasePersistence(firebaseAuth, persistenceType)

	return setFirebasePersistence(firebaseAuth, persistenceType)
		.then(() => {
			return signInWithEmailAndPassword(firebaseAuth, email, password)
				.then(userCredential => userCredential.user)
				.catch(firebaseError.parseError)
		}).catch(firebaseError.parseError)
}

/**
 * @param {*} firebaseAuth firebase auth instance
 * @param {string} email
 * @param {string} password
 * @param {string} persistenceType 'session' or 'local'
 */
async function signUpWithEmailAndPassword (firebaseAuth, email, password, persistenceType = 'session') {
	await setFirebasePersistence(firebaseAuth, persistenceType)

	return setFirebasePersistence(firebaseAuth, persistenceType)
		.then(() => {
			return createUserWithEmailAndPassword(firebaseAuth, email, password)
				.then(userCredential => userCredential.user)
				.catch(firebaseError.parseError)
		}).catch(firebaseError.parseError)
}

/**
 * @param {*} firebaseAuth firebase auth instance
 * @param {string} email
 * @param {string} password
 */
function signOutFirebaseUser (firebaseAuth) {
	return signOut(firebaseAuth)
	// .then(() => {
	// 	// Sign-out successful.
	// })
		.catch(firebaseError.parseError)
}

function signUpAnonymously (firebaseAuth) {
	return signInAnonymously(firebaseAuth)
		.then(userCredential => userCredential.user)
		.catch(firebaseError.parseError)
}

function getUserSignInMethods (auth, email) {
	return fetchSignInMethodsForEmail(auth, email)
		.then(methods => methods)
		.catch(firebaseError.parseError)
}

function reauthenticate (firebaseAuth, password) {
	const user = firebaseAuth.currentUser
	const credential = EmailAuthProvider.credential(
		user.email,
		password
	)
	return reauthenticateWithCredential(user, credential).catch(firebaseError.parseError)
}

export default {
	logout: signOutFirebaseUser,
	login: logInWithEmailAndPassword,
	signUp: signUpWithEmailAndPassword,
	reauthenticate,
	signUpAnonymously,
	getUserSignInMethods
}
